import React, { useState } from 'react';
import collect from 'collect.js';
import { Button, Skeleton } from 'antd';
import { InfoOutlined } from '@ant-design/icons';
import MetricDetailsModal from '../../modals/stats/MetricDetailsModal';
import MetricItem from './MetricItem';
import CardWrapper from '../cards/CardWrapper';

export default function Metric({
  name,
  description,
  items,
  formatter = null,
  isStatic = false,
  flipChange = false,
  loading,
  mainMetrics = [],
  reservationMetrics = [],
  marketingMetrics = [],
  storefrontMetrics = [],
  googleMetrics = [],
  excludedHistoryMetrics = [],
  renderMetricDetails = null,
  ...rest
}) {
  const [showMetricDetails, setShowMetricDetails] = useState(false);
  const hasDetailsModal = Boolean(renderMetricDetails) || !excludedHistoryMetrics?.includes('*');

  function MetricDetails() {
    if (!hasDetailsModal || !showMetricDetails) {
      return null;
    }

    if (renderMetricDetails) {
      return renderMetricDetails({ onClose: () => setShowMetricDetails(false) });
    }

    return (
      <MetricDetailsModal
        mainMetrics={mainMetrics}
        reservationMetrics={reservationMetrics}
        marketingMetrics={marketingMetrics}
        googleMetrics={googleMetrics}
        storefrontMetrics={storefrontMetrics}
        excludedHistoryMetrics={excludedHistoryMetrics}
        toggle={() => setShowMetricDetails(false)}
      />
    );
  }

  const renderItems = () => {
    if (Array.isArray(items)) {
      return items.map((item, index) => (
        <MetricItem
          key={`metric-${name}-item-${item.name}`}
          data={item}
          formatter={item.formatter ?? formatter}
          inline
          isStatic={isStatic}
          flipChange={flipChange}
          isLast={collect(items).count() - 1 === index}
        />
      ));
    }

    return <MetricItem data={items} formatter={formatter} isStatic={isStatic} flipChange={flipChange} />;
  };

  if (loading) {
    return (
      <CardWrapper title={name} className="grid grid-cols-1 gap-2" style={{ minHeight: 40 }}>
        <Skeleton />
      </CardWrapper>
    );
  }

  return (
    <>
      <CardWrapper
        title={name}
        description={description}
        className="grid grid-cols-1 gap-2"
        extra={hasDetailsModal && <Button icon={<InfoOutlined />} onClick={() => setShowMetricDetails(true)} />}
        {...rest}
      >
        {renderItems()}
      </CardWrapper>
      <MetricDetails />
    </>
  );
}
